// ==============================
//* ACCOUNT NAVIGATION SCROLL
//
//? This file manages the account navigation scroll.
// ==============================

const breakpoints = require("./utils/breakpoints");

$(() => {
    if (window.matchMedia("(max-width:" + breakpoints.md + "px)").matches) {
        const $navigationTabs = $(".account-navigation__container");
        const $activeTab = $(".account-navigation__tabs-item.active");
        let scrollTo = ($activeTab.position().left + $activeTab.width() / 2 - $navigationTabs.width() / 2);

        $navigationTabs.animate({ scrollLeft: scrollTo }, 500);
    }
});
